<template>
    <div class="not-found-view">
        <img src="../../assets/img/404.png" class="logo" />
        <div class="group">
            <h1 class="title">404</h1>
            <p class="desc">对不起，您访问的页面不存在！</p>
            <el-button type="primary" class="to-home" @click.stop.prevent="toHome">返回首页</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotFound',
    methods: {
        toHome () {
            this.$router.push({
                path: '/'
            })
        }
    }
}
</script>
<style scoped lang="less">
.not-found-view{
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    -webkit-box-orient: vertical;
    height: 100VH;
    padding-bottom: 15%;
    box-sizing: border-box;
    .logo{
        width: 50%;
        display: block;
        max-width: 600px;
    }
    .group{
        margin-top: 3%;
        text-align: center;
        margin-left: -10%;
    }
    .title{
        color: #1f1f1f;
        font-size: 30px;
        text-align: center;
    }
    .desc{
        color: #1f1f1f;
        font-size: 18px;
        text-align: center;
        padding-top: 15px;
    }
    .to-home{
        margin-top: 40px;
    }
}
</style>